module.exports = __webpack_public_path__ + "img/triste.84e633ed.png";